<template>
  <div id="app">
      <NavCompo />
      <router-view></router-view>
      <FooterCompo />
  </div>
</template>

<script>
import NavCompo from './Components/Navbar.vue'
import FooterCompo from './Components/Footer.vue'

export default {
  components: {
     NavCompo,
     FooterCompo
  }
}
</script>
